export enum FilePreviewType {
  MODEL_VIEWER = 'model',
  OFFICE_VIEWER = 'office',
  GOOGLE_VIEWER = 'google',
  PDF_VIEWER = 'pdf',
  IMAGE_VIEWER = 'image',
  VIDEO_VIEWER = 'video',
  ZIP_VIEWER = 'zip',
}
